import { makeAutoObservable, runInAction } from 'mobx';
import IntegrationsService from '../../../../services/api/integrations-service';
import { TYPE, rootContainer } from '../../../../services/container/root';
import AmazonMcfOauthCredentialsStore from '../../../integrations/products-services/stores/credentials/amazon-mcf-credentials-store';
import { IActionStoreValue, IIntegrationCategoryPreset, INTEGRATION_CATEGORY, INTEGRATION_CODE } from '../../../../models/IntegrationsTypes';

class AmazonMcfModalStore {
    private _isProcessing: boolean = false;
    private _isLoading: boolean = false;
    private _loadedPeset: IIntegrationCategoryPreset[]|null = null;
    private _credentialsStore?: AmazonMcfOauthCredentialsStore;
    private _defaultActionStoreValues: IActionStoreValue = {};

    public get isProcessing(): boolean { return this._isProcessing;  }
    public get isLoading(): boolean { return this._isLoading;  }

    private get IntegrationsService(): IntegrationsService {
        return rootContainer.get<IntegrationsService>(TYPE.IntegrationsService);
    }

    constructor(private _onSuccess: (isConnected: boolean) =>  void) {
        makeAutoObservable(this, {}, { autoBind: true });
        this._prepareCredentialsStore();
    }

    public get ceredentialStore() { return this._credentialsStore; }

    private async _loadPreset(): Promise<IIntegrationCategoryPreset[]> {
        if (this._loadedPeset) {
            return this._loadedPeset;
        }
        const preset = await this.IntegrationsService.getIntegrationsPresets(INTEGRATION_CODE.AMAZON_MCF);
        runInAction(() => {
            this._loadedPeset = preset;
        });
        return preset;
    }

    private async _prepareCredentialsStore() {
        this._isLoading = true;
        const preset = await this._loadPreset();

        const amazonMcfPresetData = preset
            .filter(c => c.id === INTEGRATION_CATEGORY.INVENTORY_TRACKING)[0]?.integrations
            .filter(i => i.id === INTEGRATION_CODE.AMAZON_MCF)[0];

        if (!amazonMcfPresetData?.credentials_params) {
            throw new Error('OAuth credentials params are not received.');
        }

        runInAction(() => {
            this._defaultActionStoreValues = {};
            amazonMcfPresetData.actions?.forEach(action => {
                this._defaultActionStoreValues[action.id] = action.default;
            });
    
            this._credentialsStore = new AmazonMcfOauthCredentialsStore(amazonMcfPresetData.credentials_params);
            this._isLoading = false;
        });
    }

    public async register() {
        if (this._isProcessing) {
            return;
        }
        this._isProcessing = true;
        try {
            const credentials = await this._credentialsStore?.getCredentials();
            const integration = await this.IntegrationsService.registerIntegration(
                credentials,
                INTEGRATION_CODE.AMAZON_MCF,
                INTEGRATION_CATEGORY.INVENTORY_TRACKING,
                this._defaultActionStoreValues,
            );

            runInAction(async () => {
                if (integration) {
                    await this._onSuccess(true);
                }
                this._isProcessing = false;
            });
        } catch (e: any) {
            runInAction(() => {
                this._isProcessing = false;
            });
            console.error(e);
        }
    }
}

export default AmazonMcfModalStore;
